import { AlertTriangle, CheckCircle, Clock } from 'lucide-react';

type SLAStatus = 'ok' | 'warning' | 'escalated' | undefined;

interface SLAFilterProps {
  selected: SLAStatus;
  onChange: (status: SLAStatus) => void;
}

const SLA_OPTIONS: { value: SLAStatus; label: string; icon: typeof Clock; color: string }[] = [
  { value: undefined, label: 'All', icon: Clock, color: 'text-font-secondary' },
  { value: 'ok', label: 'On Track', icon: CheckCircle, color: 'text-green-600' },
  { value: 'warning', label: 'Warning', icon: AlertTriangle, color: 'text-yellow-600' },
  { value: 'escalated', label: 'Escalated', icon: AlertTriangle, color: 'text-red-600' },
];

export function SLAFilter({ selected, onChange }: SLAFilterProps) {
  return (
    <div>
      <label className="flex items-center gap-2 text-sm font-medium text-font-primary mb-2">
        <Clock className="w-4 h-4" />
        SLA Status
      </label>
      <div className="flex flex-wrap gap-2">
        {SLA_OPTIONS.map((option) => {
          const Icon = option.icon;
          const isActive = selected === option.value;
          return (
            <button
              key={option.value ?? 'all'}
              onClick={() => onChange(option.value)}
              className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-full border transition-colors ${
                isActive
                  ? 'bg-brand-primary text-white border-brand-primary'
                  : 'bg-white text-font-secondary border-card-border hover:border-brand-primary'
              }`}
            >
              <Icon className={`w-3.5 h-3.5 ${isActive ? 'text-white' : option.color}`} />
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
